module.exports = __webpack_public_path__ + "img/b454b53.png";